import { render, staticRenderFns } from "./ProductImages.vue?vue&type=template&id=5c0021a9&scoped=true"
import script from "./ProductImages.vue?vue&type=script&lang=ts"
export * from "./ProductImages.vue?vue&type=script&lang=ts"
import style0 from "./ProductImages.vue?vue&type=style&index=0&id=5c0021a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0021a9",
  null
  
)

export default component.exports